"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
var react_1 = __importDefault(require("react")); // eslint-disable-line no-unused-vars
var react_dom_factories_1 = __importDefault(require("react-dom-factories"));
/**
 * Use this when you need to mark up certain text with multiple HTML elements.
 * For example, to get:
 *   <span>
 *     <a href="/gaurav" class="employee">Gaurav</a>
 *     is an employee at
 *     <a href="/indeed">Indeed</a>
 *   </span>
 * You'd do the following:
 * var markedUpComponents = {
 *          "gaurav": {
 *              componentType: DOM.a,
 *              props: { href="/gaurav", className="employee" }
 *          },
 *          "indeed": {
 *              componentType: React.createFactory(MyComponent),
 *              props: { href="/indeed" }
 *          }
 * }
 *
 * If you're calling this from a translation (which is pretty much why this exists),
 * your key should look like the following:
 * var key = "[Gaurav|{0}] is an employee at [Indeed|{1}]"
 * gt.gettext(key, ["gaurav", "indeed"])
 * <MarkupManyComponents>
 *     [Gaurav|gaurav] is an employee at [Indeed|indeed]
 * </MarkupManyComponents>
 *
 * If you need to do this for just ONE element, use MarkupSingleComponent.
 *
 * @deprecated Use `MarkupComponents` instead. See README for migration guide.
 */
var MarkupManyComponents = /** @class */ (function (_super) {
    __extends(MarkupManyComponents, _super);
    function MarkupManyComponents() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarkupManyComponents.prototype.render = function () {
        var _this = this;
        var message = "" + this.props.children;
        var completeText = [];
        var re = new RegExp('\\[([^\\]]+)\\]', 'g');
        var normalText = message.split(re);
        var startOffset = 0;
        normalText.forEach(function (elem, i) {
            if (i % 2 === 0) {
                completeText.push(elem);
                startOffset += elem.length + 1;
                return;
            }
            var textAndComponentKey = message
                .substr(startOffset, normalText[i].length)
                .split('|');
            var componentKey;
            var text;
            // if length is 1, we've been given an element with no children, like a <br /> tag.
            if (textAndComponentKey.length === 1) {
                text = null;
                componentKey = textAndComponentKey[0];
            }
            else {
                text = textAndComponentKey[0];
                componentKey = textAndComponentKey[1];
            }
            var componentData = _this.props.markedUpComponents[componentKey];
            var componentType = (componentData === null || componentData === void 0 ? void 0 : componentData.componentType) || react_dom_factories_1.default.a;
            var componentProps = __assign(__assign({}, ((componentData === null || componentData === void 0 ? void 0 : componentData.props) || {})), { children: text });
            if (!componentProps.key) {
                componentProps.key = "wrapper_" + i;
            }
            // otherwise, a React.DOM.* factory was passed in.
            // ts-ignore here because otherwise TypeScript complains not all constituents
            // of `ElementType` are callable. Which makes sense from React typings perspective
            // - e.g. component classes are not callable. But it used to be like this in JS
            // version of the code, and apparently worked with component classes ¯\_(ツ)_/¯
            // @ts-ignore
            var linkedTextCreateElementFunction = componentType(componentProps, text);
            completeText.push(linkedTextCreateElementFunction);
            startOffset += normalText[i].length + 1;
        });
        // elementType passed in was a factory from React.DOM.* or
        // React.createFactory(MyCoolComponent)
        var props = null;
        var children = completeText;
        // call the factory which returns a React.createElement
        var elementType = this.props.elementType || react_dom_factories_1.default.span;
        // ts-ignore here because otherwise TypeScript complains not all constituents
        // of `ElementType` are callable. Which makes sense from React typings perspective
        // - e.g. component classes are not callable. But it used to be like this in JS
        // version of the code, and apparently worked with component classes ¯\_(ツ)_/¯
        // @ts-ignore
        return elementType(props, children);
    };
    return MarkupManyComponents;
}(react_1.default.Component));
exports.default = MarkupManyComponents;
//# sourceMappingURL=data:application/json;base64,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